import { FormattedMessage } from 'react-intl';
import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { IconLibrary } from '@product-framework/index';
import DialogCloseButton from './DialogCloseButton';

function DuplicateJobDialog({ open, onClose, serviceJob }) {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();

  const methods = useForm();

  const { handleSubmit } = methods;
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, put } = useDataProvider(provider);

  const [loading, setLoading] = useState(false);

  async function onFormSubmit() {
    setLoading(true);

    const response = await put(
      `${getApiUrl()}/sxcl/v1/service-job/duplicate/${serviceJob?.id}`,
    );
    if (response.ok) {
      snackbar.showMessage(
        formatMessage({
          id: 'JOB_WAS_DUPLICATED_SUCCESSFULLY',
          defaultMessage: 'Job was duplicated successfully',
        }),
      );
      navigate(`/servicejobs/edit/${response.id}`);
      onClose();
    } else {
      snackbar.showMessage({
        type: 'error',
        data: formatMessage({
          id: 'ERROR_COULD_NOT_DUPLICATE_THE_JOB',
          defaultMessage: 'Error: Could not duplicate the job',
        }),
      });
    }
    setLoading(false);
  }

  const buttons = [
    {
      children: formatMessage({ id: 'YES', defaultMessage: 'Yes' }),
      type: 'submit',
      variant: 'contained',
      color: 'primary',
    },
    {
      children: formatMessage({ id: 'NO', defaultMessage: 'No' }),
      onClick: onClose,
      variant: 'contained',
      color: 'secondary',
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.ServiceJob />
        {formatMessage({
          id: 'DUPLICATE_JOB',
          defaultMessage: 'Duplicate Job',
        })}
        <DialogCloseButton disabled={loading} onClose={onClose} />
      </DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <DialogContent>
            {loading ? (
              <Box textAlign="center">
                <CircularProgress size="30px" />
                <Typography>
                  <FormattedMessage
                    id="PROCESSING"
                    defaultMessage="Processing"
                  />
                </Typography>
              </Box>
            ) : (
              <Grid2 container spacing={1}>
                <FormattedMessage
                  id="DO_YOU_WANT_TO_DUPLICATE_JOB"
                  defaultMessage="Do you want to duplicate job:"
                />{' '}
                {serviceJob?.serviceJobNumber}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions
            display="flex"
            sx={{ justifyContent: 'center', my: 2 }}>
            {buttons.map(btn => {
              const { children, ...rest } = btn;
              return (
                <Button key={children} disabled={loading} {...rest}>
                  {children}
                </Button>
              );
            })}
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
}

export default DuplicateJobDialog;
